import { render, staticRenderFns } from "./EnviarDocumentacoesView.vue?vue&type=template&id=390b9708&"
import script from "./EnviarDocumentacoesView.vue?vue&type=script&lang=js&"
export * from "./EnviarDocumentacoesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports